<script>
import PageTools from "@/components/common/page.vue";

export default {
  name: "CategoryList",
  components: { PageTools },
  data() {
    return {
      tableData: [],
      total: 0,
      currentPage: 1,
    };
  },
  methods: {
    handleCreate: function () {
      this.$router.push("/admin/category/create");
    },
    handleStatusChange: function (row) {
      this.$api
        .categoryStatus({
          id: row.id,
          status: row.status,
        })
        .then((response) => {
          this.$message({
            message: response.msg,
            type: "success",
          });
        });
    },
    fetchData: function (val) {
      this.$api
        .categoryList({
          page: val ? val : 1,
          page_size: 10,
        })
        .then((response) => {
          this.tableData = response.data.data;
          this.total = response.data.total;
        });
    },
  },
  mounted: function () {
    this.fetchData();
  },
};
</script>

<template>
  <div>
    <div style="margin-bottom: 20px; text-align: right">
      <el-button type="primary" @click="handleCreate">新增分类</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="id" label="id" width="180"> </el-table-column>
      <el-table-column prop="name" label="名称" width="180"> </el-table-column>
      <el-table-column prop="position" label="权重"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template #default="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <PageTools
      :total="this.total"
      :current-page="this.currentPage"
      @page-change="fetchData"
    ></PageTools>
  </div>
</template>

<style scoped>
table th {
  height: 60px; /* 自定义表头高度 */
  vertical-align: middle; /* 垂直居中对齐 */
}
</style>
